export default __webpack_public_path__ + "static/your-love-67ac6518c385597e1c048999dfa30b81.mp3";